import { styled } from '@mui/system';
import { FC } from 'react';
import { useIcon } from '../../Hooks/useIcon';

interface FeedbackBlockProps {
  blockPosition?: string;
  documentLink?: string;
  bgColor: string;
  padding?: string;
  iconBackground: string;
  iconColor: string;
  icon: string;
  textColor: string;
  title: string;
}

const RootDiv = styled('div')({
  margin: '7px 0',
  display: 'flex',
});

const FeedbackBlockOuterBgDiv = styled('a')<{ isLink: boolean }>(
  ({ isLink }) => ({
    borderRadius: '50px',
    padding: '10px 20px',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    cursor: isLink ? 'pointer' : 'default',
    '&:hover': {
      cursor: isLink ? 'pointer' : 'default',
      textDecoration: isLink ? 'underline' : 'none',
    },
    ...(isLink && {
      '&:hover': {
        cursor: 'pointer',
        textDecoration: 'underline',
      },
    }),
  })
);

const TitleIconDiv = styled('div')({
  fontSize: '45px',
  padding: '10px 12px 10px',
  borderRadius: '50%',
});

const TitleTextDiv = styled('p')({
  wordBreak: 'break-all',
  fontSize: '32px',
  marginLeft: '20px',
  marginBottom: '10px',
});

const FeedbackBlock: FC<FeedbackBlockProps> = ({
  blockPosition,
  documentLink,
  bgColor,
  padding,
  iconBackground,
  iconColor,
  icon,
  textColor,
  title,
}) => {
  return (
    <RootDiv style={{ justifyContent: blockPosition }}>
      <FeedbackBlockOuterBgDiv
        href={documentLink}
        isLink={!!documentLink}
        onClick={(e) => {
          if (!documentLink) e.preventDefault();
        }}
        style={{ backgroundColor: bgColor, padding }}
      >
        <TitleIconDiv style={{ backgroundColor: iconBackground }}>
          <TitleIcon color={iconColor} iconName={icon} />
        </TitleIconDiv>
        <TitleTextDiv style={{ color: textColor }}>{title}</TitleTextDiv>
      </FeedbackBlockOuterBgDiv>
    </RootDiv>
  );
};

export default FeedbackBlock;

interface TitleIconProps {
  color: string;
  iconName: string;
}

const TitleIcon: FC<TitleIconProps> = ({ color, iconName }) => {
  const Icon = useIcon({ color, iconName });
  return <>{Icon}</>;
};
